var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsNotEmptyObjectWithLVS, IsUndefinable, PlatformSourceEnum } from '@goparrot/common';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { IsArray, IsBoolean, IsDate, IsEnum, IsOptional, IsString, ValidateNested } from 'class-validator';
import { UserExposeGroup } from '../interface/user-expose-group';
import { ReadBaseUserDto } from './ReadBaseUserDto';
import { ReadUserProfileDto } from './ReadUserProfileDto';
export class ReadUserDto extends ReadBaseUserDto {
    getFullName(showLastNameFirst = false) {
        let fullName = `${this.profile.first_name} ${this.profile.last_name}`;
        if (showLastNameFirst) {
            fullName = `${this.profile.last_name} ${this.profile.first_name}`;
        }
        return fullName.replace(/\s+/g, ' ').trim();
    }
}
__decorate([
    ApiPropertyOptional({ type: () => Boolean, example: false }),
    Expose({ groups: [UserExposeGroup.MODEL, UserExposeGroup.READ] }),
    __metadata("design:type", Boolean)
], ReadUserDto.prototype, "isTest", void 0);
__decorate([
    IsOptional({ groups: [UserExposeGroup.PATCH] }),
    IsString({ groups: [UserExposeGroup.PATCH] }),
    Expose({ groups: [UserExposeGroup.MODEL, UserExposeGroup.READ, UserExposeGroup.PATCH] }),
    __metadata("design:type", String)
], ReadUserDto.prototype, "stateReason", void 0);
__decorate([
    Expose({ groups: [UserExposeGroup.MODEL, UserExposeGroup.READ] }),
    __metadata("design:type", String)
], ReadUserDto.prototype, "stateUpdatedAt", void 0);
__decorate([
    ApiProperty({ example: '018f85aa-0e4e-463e-86b3-532c14a482e8' }),
    Expose({ groups: [UserExposeGroup.MODEL, UserExposeGroup.READ, UserExposeGroup.SEARCH_RESULT] }),
    __metadata("design:type", String)
], ReadUserDto.prototype, "merchantUserId", void 0);
__decorate([
    ApiProperty({ type: () => ReadUserProfileDto }),
    Type(() => ReadUserProfileDto),
    IsOptional({ groups: [UserExposeGroup.PATCH] }),
    IsNotEmptyObjectWithLVS({ groups: [UserExposeGroup.CREATE, UserExposeGroup.SEARCH] }),
    ValidateNested({ always: true }),
    Expose({
        groups: [
            UserExposeGroup.MODEL,
            UserExposeGroup.READ,
            UserExposeGroup.CREATE,
            UserExposeGroup.PATCH,
            UserExposeGroup.SEARCH,
            UserExposeGroup.SEARCH_RESULT,
            UserExposeGroup.CONFIGURABLE,
        ],
    }),
    __metadata("design:type", ReadUserProfileDto)
], ReadUserDto.prototype, "profile", void 0);
__decorate([
    ApiPropertyOptional({ type: () => [String], example: ['tag1'] }),
    IsOptional({ always: true }),
    IsArray({ always: true }),
    IsString({ always: true, each: true }),
    Expose({ groups: [UserExposeGroup.MODEL, UserExposeGroup.CREATE, UserExposeGroup.READ] }),
    __metadata("design:type", Array)
], ReadUserDto.prototype, "tags", void 0);
__decorate([
    ApiProperty({ type: () => String, isArray: true, example: ['Vip Client'], default: [], description: 'Human tag' }),
    Expose({ groups: [UserExposeGroup.MODEL, UserExposeGroup.READ] }),
    __metadata("design:type", Array)
], ReadUserDto.prototype, "humanTags", void 0);
__decorate([
    ApiProperty({ type: () => Boolean }),
    IsBoolean({ always: true }),
    Expose({ groups: [UserExposeGroup.MODEL, UserExposeGroup.READ] }),
    __metadata("design:type", Boolean)
], ReadUserDto.prototype, "isPhoneConfirmed", void 0);
__decorate([
    ApiProperty({ type: () => Boolean }),
    IsBoolean({ always: true }),
    Expose({ groups: [UserExposeGroup.MODEL, UserExposeGroup.READ] }),
    __metadata("design:type", Boolean)
], ReadUserDto.prototype, "isEmailConfirmed", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, format: 'date-time' }),
    IsDate({ always: true }),
    IsUndefinable({ always: true }),
    Expose({ groups: [UserExposeGroup.MODEL, UserExposeGroup.READ] }),
    __metadata("design:type", Date)
], ReadUserDto.prototype, "phoneConfirmedAt", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, format: 'date-time' }),
    IsDate({ always: true }),
    IsUndefinable({ always: true }),
    Expose({ groups: [UserExposeGroup.MODEL, UserExposeGroup.READ] }),
    __metadata("design:type", Date)
], ReadUserDto.prototype, "emailConfirmedAt", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, format: 'date-time' }),
    IsDate({ always: true }),
    IsUndefinable({ always: true }),
    Expose({ groups: [UserExposeGroup.MODEL, UserExposeGroup.READ] }),
    __metadata("design:type", Date)
], ReadUserDto.prototype, "firstLoginAt", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, format: 'date-time' }),
    IsDate({ always: true }),
    IsUndefinable({ always: true }),
    Expose({ groups: [UserExposeGroup.MODEL, UserExposeGroup.READ] }),
    __metadata("design:type", Date)
], ReadUserDto.prototype, "birthdayUpdatedAt", void 0);
__decorate([
    ApiProperty({ type: () => String, enum: PlatformSourceEnum, default: PlatformSourceEnum.WEBSTORE }),
    IsEnum(PlatformSourceEnum, { always: true }),
    IsUndefinable({ always: true }),
    Expose({ groups: [UserExposeGroup.MODEL, UserExposeGroup.CREATE, UserExposeGroup.READ] }),
    __metadata("design:type", String)
], ReadUserDto.prototype, "registrationSource", void 0);
//# sourceMappingURL=ReadUserDto.js.map